<template>
  <div class="user-projects-placeholder" data-testid="user-projects-placeholder-view">
    <h1 class="user-projects-placeholder__title">
      {{ pageTitle }}
    </h1>
    <p class="user-projects-placeholder__subtitle">
      {{ $t('UserProjects.placeholder.comingSoon') }}
    </p>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  name: 'UserProjectsPlaceholderView',
  setup() {
    const route = useRoute();
    const { t } = useI18n();

    const pageTitle = computed(() => {
      const titleKey = route.meta?.titleKey;
      return titleKey ? t(titleKey) : t('UserProjects.title');
    });

    return { pageTitle };
  },
};
</script>

<style scoped>
.user-projects-placeholder {
  padding: 2rem 1.5rem;
  max-width: 48rem;
}

.user-projects-placeholder__title {
  margin: 0 0 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-dark, #1a1a1a);
}

.user-projects-placeholder__subtitle {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.95rem;
}
</style>
